import React, { useEffect } from 'react'
import './Roadmap.css'
import { FaRocket, FaExchangeAlt, FaRegMoneyBillAlt, FaFlagCheckered } from 'react-icons/fa'

// Import AOS and its styles
import AOS from 'aos'
import 'aos/dist/aos.css'
// import HowToBuy from '../HowToBuy/HowToBuy';
import Transcation from '../Utility/Utility'

export default function Roadmap() {
  useEffect(() => {
    // Initialize AOS with some configurations
    AOS.init({
      duration: 1000, // Duration for the animation
      easing: 'ease-out', // Easing for smooth animation
      once: true, // Animation happens once when the element enters the viewport
    })
  }, [])

  return (
    <div>
      <Transcation></Transcation>

      <div className="Roadmap" id="Roadmap">
        <div className="overlay"></div>
        <div className="container">
          <h1 className="HeadingFont text-center position-relative z-2" data-aos="fade-up">
            ROADMAP{' '}
          </h1>
          <p
            className="ss text-white fs-5 text-center position-relative z-2"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Our roadmap is the journey of IP Token, guiding us through various phases to build a
            strong foundation, engage the community, and achieve decentralized growth. Here's a look
            at what's ahead:
          </p>
          <div className="row position-relative justify-content-center mt-5 z-2">
            {/* Phase 1 */}
            <div className="col-md-8" data-aos="fade-up" data-aos-delay="400">
              <div className="roadMAp_box">
                <FaRocket size={40} color="white" className="mb-3" />
                <h6 className="text-white sss fw-bold fs-3">Phase 1: Presale And Staking</h6>
                <p className="ss fs-4 text-white">
                  The early supporters and buyers of IP Token from the presale will be offered a
                  unique opportunity. They will have the chance to stake their tokens directly into
                  the smart contract even before the official listing, and get high early Annual
                  Percentage Yield (APY) advantage.
                </p>
              </div>
            </div>

            {/* Phase 2 */}
            <div className="col-md-8 mt-3" data-aos="fade-up" data-aos-delay="600">
              <div className="roadMAp_box">
                <FaExchangeAlt size={40} color="white" className="mb-3" />
                <h6 className="text-white sss fw-bold fs-3">Phase 2: Liquidity Add</h6>
                <p className="ss fs-4 text-white">
                  The early liquidity provided by Uniswap listing will serve as a solid foundation
                  for the token's market presence.
                </p>
              </div>
            </div>

            {/* Phase 3 */}
            <div className="col-md-8 mt-3" data-aos="fade-up" data-aos-delay="800">
              <div className="roadMAp_box">
                <FaRegMoneyBillAlt size={40} color="white" className="mb-3" />
                <h6 className="text-white sss fw-bold fs-3">Phase 3: DEX Launch</h6>
                <p className="ss fs-4 text-white">
                  List on Uniswap, the world's largest decentralized exchange. This strategic choice
                  of platform guarantees a seamless trading experience for users, offering them the
                  best possible environment to buy, sell, and interact with IP Token. Launch price
                  is $0.0005.
                </p>
              </div>
            </div>

            {/* Phase 4 */}
            <div className="col-md-8 mt-3" data-aos="fade-up" data-aos-delay="1000">
              <div className="roadMAp_box">
                <FaFlagCheckered size={40} color="white" className="mb-3" />
                <h6 className="text-white sss fw-bold fs-3">Phase 4: Token Use Case</h6>
                <p className="ss fs-4 text-white">
                  DApps project is developing, it is MLM decentralized finance on Polygon Blockchain
                  with attractive passive rewards. The token is needed to use for registration,
                  launch date will be announced respectively.
                </p>
              </div>
            </div>

            {/* Phase 5 */}
            <div className="col-md-8 mt-3" data-aos="fade-up" data-aos-delay="1200">
              <div className="roadMAp_box">
                <FaFlagCheckered size={40} color="white" className="mb-3" />
                <h6 className="text-white sss fw-bold fs-3">Phase 5: The Road Ahead</h6>
                <p className="ss fs-4 text-white">
                  A Future of IP Token progresses through its roadmap, it remains committed to the
                  principles of fairness, innovation, and community engagement. The journey ahead
                  holds the promise of further enhancing the token's utility, amplifying its reach,
                  and contributing positively to the crypto landscape.
                </p>
              </div>
            </div>
          </div>
          {/* <HowToBuy /> */}
          {/* <button className="mt-5" data-aos="fade-up" data-aos-delay="1200">Learn More</button> */}
        </div>
      </div>
    </div>
  )
}
